
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11","cy":"11","r":"11","fill":"#4FD18B"}}),_c('path',{attrs:{"d":"M10.9909 9.00007C10.8103 9.00007 10.6654 9.05741 10.5562 9.1721C10.447 9.28679 10.3882 9.44118 10.3798 9.63527L10.3231 16.6821C10.3231 16.6865 10.3231 16.6931 10.3231 16.7019C10.3189 16.7107 10.3168 16.7173 10.3168 16.7218C10.3168 16.9335 10.384 17.1011 10.5184 17.2246C10.6486 17.3525 10.8082 17.4165 10.9972 17.4165C11.1862 17.4165 11.3479 17.3525 11.4823 17.2246C11.6125 17.1011 11.6776 16.9335 11.6776 16.7218C11.6776 16.7173 11.6776 16.7107 11.6776 16.7019C11.6776 16.6931 11.6776 16.6865 11.6776 16.6821L11.602 9.63527C11.602 9.44118 11.5474 9.28679 11.4382 9.1721C11.3248 9.05741 11.1757 9.00007 10.9909 9.00007ZM10.9972 5.49984C10.8292 5.49984 10.6759 5.54395 10.5373 5.63217C10.3987 5.71598 10.2895 5.83067 10.2097 5.97624C10.1257 6.12181 10.0837 6.28061 10.0837 6.45264C10.0837 6.62909 10.1257 6.79009 10.2097 6.93566C10.2895 7.07682 10.3987 7.1893 10.5373 7.27311C10.6759 7.36133 10.8292 7.40545 10.9972 7.40545C11.1652 7.40545 11.3185 7.36133 11.4571 7.27311C11.5957 7.1893 11.707 7.07682 11.791 6.93566C11.875 6.79009 11.917 6.62909 11.917 6.45264C11.917 6.28061 11.875 6.12181 11.791 5.97624C11.707 5.83067 11.5957 5.71598 11.4571 5.63217C11.3185 5.54395 11.1652 5.49984 10.9972 5.49984Z","fill":"white"}})])
          )
        }
      }
    